import { Text, portalColors } from "src/components";
import styled from "styled-components";

export const StyledText = styled(Text)`
    font-weight: ${ p => p.weight || 400 };
    color: ${ p => p.color || portalColors.text };
    text-align: left;
    font-size: ${ p => p.size };
    margin: ${ p => p.margin || "1px" };
    text-align: ${ p => p.align || "left"};
`;

export const MainContainer = styled.div`
    display: flex;
    gap: 11px;
    height: calc(100vh - 4rem);
    min-height: 0;
    padding: 1rem 0;
    background: var(--calendar-bg, #F5F7FB);
    flex-direction: row;
    box-sizing: border-box;

    @media (max-width: 800px) {
        height: auto;
        flex-direction: column;
        padding: 1rem 0;
    }

    ::-webkit-scrollbar {
        width: 0.375rem;
        height: 0.5rem;
        border-radius: 0.375rem;
        border-right: none;
        border-left: none;
    }

    ::-webkit-scrollbar-thumb {
        background-color: var(--calendar-border-strong, #DBE5ED);
        border-radius: 0.375rem;
    }

    ::-webkit-scrollbar-track {
        background: ${portalColors.surfaceSoft};
        margin-left: 1.875rem;
    }

    ::-webkit-scrollbar-track-piece:start {
        background-color: ${portalColors.surfaceSoft};
        border-radius: 0.375rem;
    }

    ::-webkit-scrollbar-track-piece:start {
        background-color: ${portalColors.surfaceSoft};
        border-radius: 0.375rem;
    }
`;

export const LeftContainer = styled.div`
    width: 23.375rem;
    border: 1px solid ${portalColors.border};
    border-radius: 16px;
    overflow: hidden;
    height: 100%;
    min-height: 0;
    background: ${portalColors.surface};
    box-shadow: ${portalColors.shadow};

    @media (max-width: 800px) {
        max-width: 100%;
        width: 100%;
        margin-top: 1rem;
    }
`;

export const RightContainer = styled.div`
    flex: 1;
    border: 1px solid ${portalColors.border};
    border-radius: 16px;
    max-width: 950px;
    overflow: hidden;
    height: 100%;
    min-height: 0;
    background: ${portalColors.surface};
    box-shadow: ${portalColors.shadow};

    @media (max-width: 800px) {
        max-width: 100%;
        width: 100%;
        margin-top: 1rem;
    }
`;
